import { IProfileResponse } from "services/profile";
import { Typography } from "components/Typography";
import styled from "styled-components";

interface IProps {
  profile: IProfileResponse;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem; 
  gap: 1rem;
  border-radius: 0rem;
  cursor: pointer;
  @media (min-width: 800px) { 
    gap: 0.5rem;
    padding: 0;
  }
`;
const Image = styled.img`
  min-width: 2rem;
  width: 2rem;
  height: 2rem;
  margin-right: 0rem;
  @media (min-width: 800px) {
    min-width:1.5rem;
    width: 1.5rem;
    height: 1.5rem; 
  }
`;
 
export const Profile = ({ profile }: IProps) => {
  return (
    <Wrapper>
      <Image src={profile.iconUrl} />
      <Typography variant="h4">{profile.name}</Typography>
    </Wrapper>
  );
};
